export type IFileExtension = "IMAGE" | "PDF" | "EXCEL" | "OTHER";

export const convertBase64ToBlob = (base64Image: string) => {
    const parts = base64Image.split(";base64,");
    const imageType = parts[0].split(":")[1];
    const decodedData = window.atob(parts[1]);
    const uInt8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: imageType });
  };

  export const getFileExtensionType = (fileName: string): IFileExtension => {
    if (!fileName || typeof fileName !== "string") {
      return "OTHER";
    }
    const extension = fileName?.split(".").pop()?.toLocaleLowerCase();
    if (
      extension === "jpg" ||
      extension === "jpeg" ||
      extension === "png" ||
      extension === "webp" ||
      extension === "jfif" ||
      extension === "tif"
    )
      return "IMAGE";
    if (extension === "pdf") return "PDF";
    if (extension === "xls" || extension === "xlsx") return "EXCEL";
    return "OTHER";
  };